// Список тем (тільки активні + з видимими питаннями для категорії прав юзера).
// Виокремлено з Categories — щоб /categories залишалась хабом режимів.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useFetch } from '../lib/useFetch';
import { Loader } from '../components/Loader';
import { ErrorView } from '../components/ErrorView';
import { PageHeader } from '../components/PageHeader';
import { haptic } from '../lib/telegram';

export function Topics() {
  const navigate = useNavigate();
  const { data, loading, error, reload } = useFetch(() => api.categories(), []);
  const [starting, setStarting] = useState(false);
  const [startError, setStartError] = useState<string | null>(null);

  async function start(categoryId: number) {
    setStarting(true);
    setStartError(null);
    haptic.medium();
    try {
      const res = await api.startAttempt({ mode: 'CATEGORY', categoryId });
      navigate(`/test/${res.attemptId}`, { state: res });
    } catch (e) {
      setStartError(e instanceof ApiError ? e.message : 'Не вдалося розпочати тест');
      haptic.error();
    } finally {
      setStarting(false);
    }
  }

  return (
    <>
      <PageHeader
        title="Вчи по темах"
        subtitle="Усі питання теми, без обмежень за часом"
        right={
          <button onClick={() => navigate('/categories')} className="text-sm text-tg-link">
            Назад
          </button>
        }
      />
      <div className="space-y-4 p-4">
        {loading && <Loader />}
        {error && <ErrorView error={error} onRetry={reload} />}

        {startError && (
          <div className="card border border-tg-destructive text-sm text-tg-destructive">
            {startError}
          </div>
        )}

        {data && (
          <section className="space-y-2">
            {data.length === 0 && (
              <p className="card text-sm text-tg-hint">
                Тем для твоєї категорії прав ще немає. Зміни категорію в Профілі.
              </p>
            )}
            {data.map((c) => (
              <button
                key={c.id}
                disabled={starting || c.questionCount === 0}
                onClick={() => start(c.id)}
                className="card flex w-full items-center justify-between text-left hover:bg-tg-bg/40 disabled:opacity-50"
              >
                <div className="flex-1 pr-3">
                  <div className="font-medium">{c.nameUk}</div>
                  {c.description && <div className="text-xs text-tg-hint">{c.description}</div>}
                </div>
                <div className="text-right">
                  <div className="text-xs text-tg-hint">
                    {c.questionCount > 0 ? `${c.questionCount} пит.` : 'Скоро'}
                  </div>
                </div>
              </button>
            ))}
          </section>
        )}
      </div>
    </>
  );
}
